export const WEEKEND_DAYS = ["sat", "sun"];
